import { CaDialogComponent } from '../../../../shared/dialogs/ca-dialog.base'
import { Component, Inject, OnDestroy } from '@angular/core'
import { Store } from '@ngrx/store'
import { selectNotificationDetail } from '../../state/main-view.selectors'
import { Subscription } from 'rxjs'

@Component({
    selector: 'ca-notification-detail',
    templateUrl: './notification-detail.html',
    standalone: false
})
export class NotificationDetailDialogComponent extends CaDialogComponent<{}, void>
    implements OnDestroy {

    notification: any

    #selectNotificationDetail: Subscription

    constructor(@Inject(Store) private store: Store,
                ) {
        super()

        this.#selectNotificationDetail = this.store.select(selectNotificationDetail).subscribe(data => {
            this.notification = data
        })
    }

    ngOnDestroy(): void {
        this.#selectNotificationDetail?.unsubscribe()
    }

    closeModal(): void {
        super.close()

    }
}
